import { FC, SetStateAction } from "react";
import cx from "classnames";

import useShallowSelector from "./../../../../../../hooks/useShalowSelector";

import LogicStateSelect, { IOptions } from "./../../ConditionList/Condition/StateSelect/LogicStateSelect";
import { selectPages } from "./../../../../../../store/pages/selectors";
import { IRule } from "./../../../../../../store/logic/types";
import { ILogicOptions } from "./../../../../../../libs/logicSelect";
import Icon, { IconTypes } from "./../../../../../../libs/Icon";
import Button from "./../../../../../../libs/Button";
import { LoginActions } from "./../../LogicTypes";

import styles from "./styles.module.scss";

interface IOption {
    [key: string]: string;
}

interface IProps {
    index: number;
    rule: IRule;
    setRule: (value: SetStateAction<IRule>) => void;
    sortedActionFields: ILogicOptions;
}

const Action: FC<IProps> = ({ index, rule, setRule, sortedActionFields }) => {
    const pages = useShallowSelector(selectPages);
    const isPage = rule.actions[index].action === "SHOW_PAGE" || rule.actions[index].action === "HIDE_PAGE";
    const pageSelectOptions = Object.keys(pages).reduce((acc, current: any) => {
        return { ...acc, [current]: pages[current].title };
    }, {});

    const fieldSelectOptions = Object.keys(sortedActionFields).reduce<IOption>((accumulator: IOption, current) => {
        return { ...accumulator, [current]: sortedActionFields[current].label };
    }, {});

    const handleAddAction = () => {
        rule.actions.push({ _id: "", action: "" });
        setRule({ ...rule });
    };

    const getLogicAction = (actionType: string | undefined | IOptions["key"]) => {
        if (actionType === "SHOW_PAGE" || actionType === "HIDE_PAGE") {
            return pageSelectOptions;
        } else if (actionType === "SENT_TO_OTHER_EMAIL") {
            return { "": "" };
        }
        return fieldSelectOptions;
    };

    return (
        <div key={index} className={styles.actionDiv}>
            <LogicStateSelect
                placeholder="Action"
                className={styles.selectAction}
                handleChange={newKey => {
                    rule.actions[index].action = newKey;
                    setRule({ ...rule });
                }}
                options={LoginActions}
                valueKey={rule.actions[index].action}
            />
            <LogicStateSelect
                placeholder={isPage ? "Select a page" : "Select a field"}
                className={styles.selectField}
                handleChange={newKey => {
                    rule.actions[index]._id = newKey;
                    setRule({ ...rule });
                }}
                options={getLogicAction(rule.actions[index].action)}
                valueKey={rule.actions[index]._id}
                useListWithPortal
            />
            {rule.actions.length !== 1 && rule.actions.length - 1 !== index ? (
                <div className={styles.deleteBtn}>
                    <span className={styles.trashDecoration}></span>
                    <Icon
                        type={IconTypes.TRASH}
                        size={20}
                        onClick={() => {
                            rule.actions.splice(index, 1);
                            setRule({ ...rule });
                        }}
                    />
                    <span className={styles.trashDecoration}></span>
                </div>
            ) : null}
            {index === rule.actions.length - 1 ? (
                <div className={styles.actionBtns}>
                    <Button
                        className={cx(styles.addActionBtn, {
                            [styles.shortActionBtn]: index > 0,
                        })}
                        text="Add Action"
                        leftIcon={IconTypes.ADD}
                        onClick={handleAddAction}
                    ></Button>
                    {index > 0 ? (
                        <Icon
                            type={IconTypes.TRASH}
                            className={styles.lastTrash}
                            size={20}
                            onClick={() => {
                                rule.actions.splice(index, 1);
                                setRule({ ...rule });
                            }}
                        />
                    ) : null}
                </div>
            ) : null}
        </div>
    );
};

export default Action;
